import { ColumnsType } from "antd/es/table";
import { Space, Dropdown } from "antd";
import { BotoesAcoes } from "../../ViewGerenciarPostagens/styles"; // Botões de ação
import SettingsIcon from "@mui/icons-material/Settings";
import { getMenuItems } from "../constants/itemsActionColumns";
import ColumnSearch from "../../../components/ColumnSearch";

export const Columns = (
  onClick: (e: any) => void,
  setPostagemId: (e: any) => void,
  setObservacao: (e: any) => void,
  filteredInfo: {
    nome?: string[] | null;
    telefone?: string[] | null;
    tipo?: string[] | null;
    nomeEmpreend?: string[] | null;
    tipoInteresse?: string[] | null;
    troca?: string[] | null;
    aluguel?: string[] | null;
    compra?: string[] | null;
    venda?: string[] | null;
    dataIni?: string[] | null;
    dataFim?: string[] | null;
    fonte?: string[] | null;
    grupo?: string[] | null;
    dataDivulgacao?: string[] | null;
  }
): ColumnsType<any> => {
  const items = getMenuItems();

  return [
    {
      title: "Nome",
      dataIndex: "nome",
      key: "nome",
      width: "30%",
      filteredValue: filteredInfo.nome || null,
      onFilter: (value, record) => record.nome.includes(value),
      ...ColumnSearch<any>({ dataIndex: "nome" }),
    },
    {
      title: "Telefone",
      dataIndex: "telefone",
      key: "telefone",
      width: "30%",
      filteredValue: filteredInfo.telefone || null,
      onFilter: (value, record) => record.telefone.includes(value),
      ...ColumnSearch<any>({ dataIndex: "telefone" }),
    },
    {
      title: "Tipo",
      dataIndex: "tipo",
      key: "tipo",
      width: "30%",
      filteredValue: filteredInfo.tipo || null,
      onFilter: (value, record) => record.tipo.includes(value),
      filters: [
        { text: "Lead", value: "Lead" },
        { text: "Revendedor", value: "Revendedor" },
        { text: "Proprietario", value: "Proprietario" },
        { text: "Golpista", value: "Golpista" },
      ],
      filterSearch: true,
    },
    {
      title: "Empreendimento",
      dataIndex: "nomeEmpreend",
      key: "nomeEmpreend",
      width: "30%",
      filteredValue: filteredInfo.nomeEmpreend || null,
      onFilter: (value, record) => record.nomeEmpreend.includes(value),
      filterSearch: true,
      ...ColumnSearch<any>({ dataIndex: "nomeEmpreend" }),
    },
    {
      title: "Tipo Interesse",
      dataIndex: "tipoInteresse",
      key: "tipoInteresse",
      width: "30%",
      filters: [
        { text: "Procura", value: "Procura" },
        { text: "Disponibiliza", value: "Disponibiliza" },
      ],
      filteredValue: filteredInfo.tipoInteresse || null,
      onFilter: (value, record) => record.tipoInteresse.includes(value),

      filterSearch: true,
    },
    {
      title: "TR",
      dataIndex: "troca",
      key: "troca",
      width: "30%",
      filteredValue: filteredInfo.troca || null,
      onFilter: (value, record) => record.troca.includes(value),
      filters: [
        { text: "Sim", value: "Sim" },
        { text: "Não", value: "Não" },
      ],
      filterSearch: true,
    },
    {
      title: "AL",
      dataIndex: "aluguel",
      key: "aluguel",
      width: "30%",
      filteredValue: filteredInfo.aluguel || null,
      onFilter: (value, record) => record.aluguel.includes(value),
      filters: [
        { text: "Sim", value: "Sim" },
        { text: "Não", value: "Não" },
      ],
      filterSearch: true,
    },
    {
      title: "Compra",
      dataIndex: "compra",
      key: "compra",
      width: "30%",
      filteredValue: filteredInfo.compra || null,
      onFilter: (value, record) => record.compra.includes(value),
      filters: [
        { text: "Sim", value: "Sim" },
        { text: "Não", value: "Não" },
      ],
      filterSearch: true,
    },
    {
      title: "Venda",
      dataIndex: "venda",
      key: "venda",
      width: "30%",
      filteredValue: filteredInfo.venda || null,
      onFilter: (value, record) => record.venda.includes(value),
      filters: [
        { text: "Sim", value: "Sim" },
        { text: "Não", value: "Não" },
      ],
      filterSearch: true,
    },
    {
      title: "Data Inicio",
      dataIndex: "dataIni",
      key: "dataIni",
      width: "30%",
      filteredValue: filteredInfo.dataIni || null,
      onFilter: (value, record) => record.dataIni.includes(value),
      filterSearch: true,
      ...ColumnSearch<any>({ dataIndex: "dataIni" }),
    },
    {
      title: "Data Fim",
      dataIndex: "dataFim",
      key: "dataFim",
      width: "30%",
      filteredValue: filteredInfo.dataFim || null,
      onFilter: (value, record) => record.dataFim.includes(value),
      filterSearch: true,
      ...ColumnSearch<any>({ dataIndex: "dataFim" }),
    },
    {
      title: "Fonte",
      dataIndex: "fonte",
      key: "fonte",
      width: "30%",
      filteredValue: filteredInfo.fonte || null,
      onFilter: (value, record) => record.fonte.includes(value),
      filterSearch: true,
      ...ColumnSearch<any>({ dataIndex: "fonte" }),
    },
    {
      title: "Grupo",
      dataIndex: "grupo",
      key: "grupo",
      width: "30%",
      filteredValue: filteredInfo.grupo || null,
      onFilter: (value, record) => record.grupo.includes(value),
      filterSearch: true,
      ...ColumnSearch<any>({ dataIndex: "grupo" }),
    },
    {
      title: "Data Divulgação",
      dataIndex: "dataDivulgacao",
      key: "dataDivulgacao",
      width: "30%",
      filteredValue: filteredInfo.dataDivulgacao || null,
      onFilter: (value, record) => record.dataDivulgacao.includes(value),
      filterSearch: true,
      ...ColumnSearch<any>({ dataIndex: "dataDivulgacao" }),
    },

    {
      title: "Ações",
      dataIndex: "operation",
      key: "operation",
      width: "10%",
      align: "center",
      filteredValue: null,
      render: (item, row) => (
        <Space size="middle">
          <Dropdown menu={{ items, onClick }} trigger={["click"]}>
            <BotoesAcoes
              onClick={() => {
                setPostagemId(row.key);
                setObservacao(row.observacao);
              }}
            >
              <Space>
                <SettingsIcon />
              </Space>
            </BotoesAcoes>
          </Dropdown>
        </Space>
      ),
    },
  ];
};
